import { render } from "./bread_crumbs.vue?vue&type=template&id=13e61f88&scoped=true"
import script from "./bread_crumbs.vue?vue&type=script&lang=js"
export * from "./bread_crumbs.vue?vue&type=script&lang=js"

import "./bread_crumbs.vue?vue&type=style&index=0&id=13e61f88&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13e61f88"]])

export default __exports__